import { useState } from "react";
import { learnPoints, faqs } from "@/mocks/homeData";

const icons = ["ri-search-line", "ri-flask-line", "ri-timer-flash-line", "ri-heart-line"];

export default function Learn() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="learn" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-sm font-medium tracking-wide text-primary-600">吃瓜小课堂 · FAQ</p>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">理性吃瓜，从看懂开始</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-foreground-600">
            吃瓜可以，但别被热度带着走。记住这四条小原则，再大的瓜也能保持清醒。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {learnPoints.map((p, i) => (
            <div key={i} className="rounded-2xl border border-background-200/70 bg-background-100 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-500 text-foreground-950">
                <i className={`${icons[i]} text-xl`} aria-hidden="true"></i>
              </span>
              <p className="mt-4 text-sm leading-7 text-foreground-800">{p}</p>
            </div>
          ))}
        </div>

        <div className="mx-auto mt-14 max-w-3xl">
          <h3 className="font-heading text-xl font-bold text-foreground-900 md:text-2xl">关于今日大瓜，你常问的几个问题</h3>
          <div className="mt-6 space-y-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div key={i} className={`overflow-hidden rounded-2xl border transition-colors ${open ? "border-primary-300 bg-background-100" : "border-background-200/70 bg-background-100"}`}>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-base font-semibold leading-6 text-foreground-900">{f.q}</span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"}`}>
                      <i className={`ri-add-line text-lg transition-transform ${open ? "rotate-45" : ""}`} aria-hidden="true"></i>
                    </span>
                  </button>
                  <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-7 text-foreground-700">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}